__turbopack_context__.v({
  "embla": "CarouselFooterCard-module__PYFnmG__embla",
  "emblaContainer": "CarouselFooterCard-module__PYFnmG__emblaContainer",
  "emblaSlide": "CarouselFooterCard-module__PYFnmG__emblaSlide",
  "footerItemContent": "CarouselFooterCard-module__PYFnmG__footerItemContent",
  "imageContainer": "CarouselFooterCard-module__PYFnmG__imageContainer",
  "plus": "CarouselFooterCard-module__PYFnmG__plus",
  "root": "CarouselFooterCard-module__PYFnmG__root",
  "square": "CarouselFooterCard-module__PYFnmG__square",
});
